import { Container, Row, Col } from "react-bootstrap";
import { useState, useEffect, useCallback } from "react";
import "../components/button.css";
import Button from "@mui/material/Button";
import LogoutIcon from "@mui/icons-material/Logout";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { TextField } from "@mui/material";
import Alerts from "../components/Alerts";
import { apiRequest } from "../components/Config";
import { marginBottom, marginTop } from "../App";
import { useNavigate } from "react-router-dom";
import { fetchUserData } from "../components/auth";
import Dropzone from "react-dropzone";
import { Formik, Form as FormikForm, Field } from "formik";
import axios from "axios";
import { API_URL } from "../App";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { Modal } from "react-bootstrap";

const Files = ({ hideFooter }) => {
  const API_BASE = "https://tomaszfotograf.pl/files/mini/";
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [text, setText] = useState("Pobieranie danych...");
  const [apiResponse, setApiResponse] = useState({});
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [showAddFile, setShowAddFile] = useState(false);
  const [showFiles, setShowFiles] = useState(true);
  const [status, setStatus] = useState(0);
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [editRow, setEditRow] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [show, setShow] = useState(false);
  const [deleted, setDeleted] = useState(0);

  const handleClose = () => setShow(false);
  useEffect(() => {
    hideFooter(true);
    return () => hideFooter(false);
  }, [hideFooter]);

  const handleDelete = (id) => {
    setDeleted(id);
    setShow(true);
    console.log("ID: ", id);
  };

  const handleDeletePosition = async () => {
    console.log("Delete: ", deleted);

    if (!deleted || !userData) return;

    try {
      const response = await apiRequest("delete", "POST", {
        id: deleted,
      });

      console.log("Response: ", response);

      setDeleted(null);
      setShow(false);
      fetchData();
    } catch (error) {
      console.error("Błąd podczas usuwania pozycji:", error);
    }
  };

  useEffect(() => {
    const verifyUser = async () => {
      try {
        const userDataAnswer = await fetchUserData();
        if (userDataAnswer && userDataAnswer.userId) {
          setUserData(userDataAnswer);
        } else {
          navigate("/login");
        }
      } catch (error) {
        console.error("Error during user verification:", error);
      }
    };
    verifyUser();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiRequest(`photosdb`, "GET");
        setData(response);

        if (response.length === 0) setText("Brak dokumentów...");
        setStatus(response.status);
      } catch (error) {
        setError(error.message);
      }
    };
    if (userData && userData.userId) {
      fetchData();
    }
  }, [userData]);

  const fetchData = async () => {
    try {
      const response = await apiRequest(`photosdb`, "GET");
      setData(response);

      if (response.length === 0) setText("Brak dokumentów...");
      setStatus(response.status);
    } catch (error) {
      setError(error.message);
    }
  };

  const handleRow = async (id, value, field) => {
    //console.log("Row, value:", id, value, field);
    try {
      const response = await apiRequest("sort", "POST", {
        id,
        value,
        field,
      });
      fetchData();
      console.log("Zaktualizowano opis:", response);
    } catch (error) {
      console.error("Błąd podczas zapisu opisu:", error);
    }
  };

  useEffect(() => {
    if (showApiResponse) {
      const timer = setTimeout(() => {
        setShowApiResponse(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
    setShowAddFile(false);
    setShowFiles(true);
  }, [showApiResponse]);

  const logout = async () => {
    try {
      await apiRequest("logout", "POST");
      setUserData({
        userId: 0,
        user: "",
        fullName: "",
      });
      navigate("/login");
    } catch (error) {
      console.error("Błąd podczas wylogowywania:", error);
    }
  };
  const handleShowAddFile = () => {
    setShowAddFile(!showAddFile);
    setShowApiResponse(false);
  };

  const handleUpload = async (values, { setSubmitting }) => {
    console.log("handleUpload called", values, selectedFile);

    try {
      //console.log("tu jestem", values.file.name);
      if (!values.file.name) {
        setApiResponse({
          title: "Informacja",
          severity: "warning",
          info: "Musisz wybrać zdjęcie do załadowania.",
        });
        setShowApiResponse(true);
        return;
      }

      const fd = new FormData();
      fd.append("file", selectedFile);
      fd.append("userId", userData.userId);

      Object.entries(values).forEach(([key, val]) => {
        fd.append(key, val || "");
      });

      console.log("ValuesUpload: ", values);

      const response = await axios.post(`${API_URL}/upload`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
      });
      console.log("uplod response: ", response);
      if (response.data.fileId > 0) {
        setApiResponse({
          title: "Informacja",
          severity: "success",
          info: "Zdjęcie zostało poprawnie załadowane.",
        });
        setShowApiResponse(true);
        setSelectedFile(null);
        fetchData();
      } else {
        setApiResponse({
          title: "Informacja",
          severity: "warning",
          info: "Wystąpił błąd podczas importu pliku.",
        });
        setShowApiResponse(true);
      }
    } catch (error) {
      console.error("Błąd: ", error.status);
      setApiResponse({
        title: "Informacja",
        severity: "warning",
        info: "Nieznany błąd podczas importu pliku. Zgłoś problem Administratorowi. Prawdopodobna przyczyna: plik o takiej nazwie jest już w systemie.",
      });
      setShowApiResponse(true);
    } finally {
      setSubmitting(false);
    }

    setSubmitting(false);
  };

  const initialValues = {
    file: null,
  };
  return (
    <div>
      {showApiResponse && (
        <Row>
          <Alerts data={apiResponse} />
        </Row>
      )}

      {showFiles && (
        <>
          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Potwierdzenie</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Czy na pewno usunąć tę pozycję? Jeśli tak, to zapamiętaj nr sort
            </Modal.Body>
            <Modal.Footer>
              <Row>
                <Col md="4">
                  <Button variant="outlined" onClick={handleClose}>
                    Anuluj
                  </Button>
                </Col>
                <Col md="4"></Col>
                <Col md="4">
                  <Button variant="contained" onClick={handleDeletePosition}>
                    Usuń
                  </Button>
                </Col>
              </Row>
            </Modal.Footer>
          </Modal>
          <Container style={{ paddingTop: "10px" }}>
            <Row style={{ marginBottom }}>
              <Col md="2" xs="6">
                <Button
                  variant="outlined"
                  color="success"
                  size="small"
                  onClick={handleShowAddFile}
                  style={{ minWidth: "88px" }}
                >
                  <FileUploadIcon />
                </Button>
              </Col>

              <Col md="2" xs="6">
                <Button
                  variant="outlined"
                  color="warning"
                  size="small"
                  onClick={logout}
                  style={{ minWidth: "88px" }}
                >
                  <LogoutIcon onClick={logout} />
                  wyloguj
                </Button>
              </Col>
            </Row>
          </Container>
          <Container>
            {showAddFile && (
              <Formik
                initialValues={initialValues}
                //validationSchema={validationSchema}
                validationSchema={null}
                onSubmit={(values, formikHelpers) => {
                  //console.log("Formik onSubmit fired: ", values);
                  handleUpload(values, formikHelpers);
                }}
              >
                {({
                  values,
                  setFieldValue,
                  isSubmitting,
                  errors,
                  touched,
                  setFieldTouched,
                }) => {
                  //console.log("Errors:", errors);
                  //console.log("Formik Values:", values);
                  return (
                    <Container style={{ paddingTop: "100px" }}>
                      <FormikForm>
                        <Dropzone
                          onDrop={(acceptedFiles) => {
                            setFieldValue("file", acceptedFiles[0]);
                            setFieldTouched("file", true);
                          }}
                          multiple={false}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div
                              {...getRootProps()}
                              style={{
                                border: "2px dashed #4a6587",
                                padding: "30px",
                                cursor: "pointer",
                              }}
                            >
                              <input {...getInputProps()} />
                              <p>
                                Przeciągnij i upuść zdjęcie w formacie JPG tutaj
                                lub kliknij, aby wybrać je z dysku.
                              </p>
                              {values.file && (
                                <p>Wybrano: {values.file.name}</p>
                              )}
                            </div>
                          )}
                        </Dropzone>
                        {errors.file && touched.file && (
                          <div style={{ color: "red" }}> {errors.file}</div>
                        )}

                        <Button
                          type="submit"
                          variant="outlined"
                          disabled={isSubmitting}
                          style={{ marginTop: "20px", marginBottom: "20px" }}
                        >
                          Zapisz
                        </Button>
                      </FormikForm>
                    </Container>
                  );
                }}
              </Formik>
            )}
          </Container>
          <Container>
            <div className="table-wrapper">
              <table className="table table-bordered table-hover table-sticky">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Nazwa</th>
                    <th>Podgląd</th>
                    <th>Data</th>
                    <th>Sort</th>
                    <th>Skasuj</th>
                  </tr>
                </thead>

                <tbody>
                  {data && data.length > 0 ? (
                    [...data]
                      .sort((a, b) => {
                        const descA = a.description
                          ? a.description.toLowerCase()
                          : "";
                        const descB = b.description
                          ? b.description.toLowerCase()
                          : "";
                        if (!descA && !descB) return 0;
                        if (!descA) return 1;
                        if (!descB) return -1;
                        return descA.localeCompare(descB);
                      })
                      .map((item, index) => (
                        <tr
                          key={item.id}
                          style={{ cursor: "pointer" }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <td style={{ width: "50px" }}>{index + 1}</td>

                          <td
                            style={{ width: "250px" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setEditRow(item.id + "-fileoriginal");
                              setEditValue(item.fileoriginal || "");
                            }}
                          >
                            {editRow === item.id + "-fileoriginal" ? (
                              <TextField
                                variant="standard"
                                autoFocus
                                fullWidth
                                value={editValue}
                                onChange={(e) => setEditValue(e.target.value)}
                                onClick={(e) => e.stopPropagation()}
                                onBlur={() => {
                                  handleRow(item.id, editValue, "fileoriginal");
                                  setEditRow(null);
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    handleRow(
                                      item.id,
                                      editValue,
                                      "fileoriginal"
                                    );
                                    setEditRow(null);
                                  }
                                }}
                              />
                            ) : (
                              item.fileoriginal
                            )}
                          </td>

                          <td style={{ width: "150px" }}>
                            <img
                              src={`${API_BASE}${item.fileoriginal}`}
                              alt={`miniatura-${item.id}`}
                              style={{
                                width: "100%",
                                maxWidth: 150,
                                height: "auto",
                                objectFit: "cover",
                                cursor: "pointer",
                                padding: 0,
                                background: "#fff",
                                borderRadius: 0,
                                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                transition: "transform 0.2s",
                              }}
                            />
                          </td>

                          <td style={{ width: "80px" }}>{item.created}</td>

                          <td
                            style={{ width: "100px" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setEditRow(item.id + "-description");
                              setEditValue(item.description || "");
                            }}
                          >
                            {editRow === item.id + "-description" ? (
                              <TextField
                                variant="standard"
                                autoFocus
                                fullWidth
                                value={editValue}
                                onChange={(e) => setEditValue(e.target.value)}
                                onClick={(e) => e.stopPropagation()}
                                onBlur={() => {
                                  handleRow(item.id, editValue, "description");
                                  setEditRow(null);
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    handleRow(
                                      item.id,
                                      editValue,
                                      "description"
                                    );
                                    setEditRow(null);
                                  }
                                }}
                              />
                            ) : (
                              item.description
                            )}
                          </td>
                          <td style={{ width: "50px" }}>
                            <Button
                              variant="contained"
                              color="error"
                              size="small"
                              onClick={() => {
                                handleDelete(item.id, editValue, "description");
                                setDeleted(item.id);
                              }}
                              style={{ minWidth: "88px" }}
                            >
                              <DeleteForeverIcon />
                            </Button>
                          </td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td colSpan="10" style={{ textAlign: "center" }}>
                        <p>{text}</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Container>
        </>
      )}
    </div>
  );
};
export default Files;
